import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, ChevronRight } from 'lucide-react';
import api from '../utils/api';
import { appTemplates } from '../templates';

const RecentTemplates = () => {
  const navigate = useNavigate();
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    const fetchRecent = async () => {
      try {
        const res = await api.get('/templates/recent');
        setRecent(res.data.templates || []);
      } catch { /* silent */ }
    };
    fetchRecent();
  }, []);

  if (recent.length === 0) return null;

  const handleClick = (templateId) => {
    const tpl = appTemplates.find(t => t.id === templateId);
    if (tpl) {
      navigate('/new-project', {
        state: { template: { name: tpl.name, description: tpl.description, style: 'modern', stack: tpl.stack, aiModel: tpl.aiModel } }
      });
    }
  };

  return (
    <div className="px-4 pt-3 pb-1" data-testid="recent-templates-section">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider flex items-center gap-1.5">
          <Clock className="w-3 h-3" /> Recently Used
        </h2>
        <button
          onClick={() => navigate('/templates')}
          className="text-xs text-blue-400 hover:text-blue-300 flex items-center gap-0.5"
          data-testid="recent-view-all-btn"
        >
          All <ChevronRight className="w-3 h-3" />
        </button>
      </div>
      <div className="space-y-1">
        {recent.slice(0, 3).map(item => {
          const tpl = appTemplates.find(t => t.id === item.template_id);
          if (!tpl) return null;
          return (
            <button
              key={item.template_id}
              onClick={() => handleClick(item.template_id)}
              className="w-full flex items-center gap-2.5 p-2 rounded-lg hover:bg-muted transition-all text-left group"
              data-testid={`recent-template-${item.template_id}`}
            >
              <span className="text-lg">{tpl.icon}</span>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-foreground/80 group-hover:text-foreground truncate">{tpl.name}</p>
                <p className="text-xs text-muted-foreground/70">{item.use_count}x used</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default RecentTemplates;
